/**
 * @summary: Represents information about a property that has changed.
 * @description: Contains information to identify the property, what it's old was and what the new value is
 */
export class PropertyChangedInformation {
    public propertyName: string = '';
    public oldValue: any | null;
    public newValue: any | null;

    constructor();
    constructor(propertyName: string, oldValue: any, newValue: any);
    constructor(propertyName?: string, oldValue?: any, newValue?: any) {
        if (propertyName !== undefined) {
            this.propertyName = propertyName;
            this.oldValue = oldValue;
            this.newValue = newValue;
        }
    }
}